import { useEffect, useState } from "react";
import { apiClient } from "../../../apiclient/apiclient";

const UserStatsRows = () => {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    clients: 0,
    admins: 0,
    delivery: 0,
  });

  /* ----------------------------
     LOAD USER STATS
  ----------------------------- */
  useEffect(() => {
    const loadStats = async () => {
      try {
        const res = await apiClient.get("/user-stats");

        setStats({
          clients: res.data.clients || 0,
          admins: res.data.admins || 0,
          delivery: res.data.delivery || 0,
        });
      } catch (err) {
        console.error("Failed to load user stats", err);
      } finally {
        setLoading(false);
      }
    };

    loadStats();
  }, []);

  /* ===============================
     🔹 STAT ROW
  ================================ */
  const StatRow = ({ label, value, dot }) => (
    <div className="flex items-center justify-between bg-white px-3 py-2 border-b border-gray-100 h-11 gap-2 last:border-b-0">
      <div className="flex items-center gap-2">
        <span className={`h-2 w-2 rounded-full ${dot}`} />
        <span className="text-xs text-gray-600 font-medium">{label}</span>
      </div>
      <span className="text-sm font-bold text-slate-800">
        {typeof value === "number" ? value.toLocaleString() : value}
      </span>
    </div>
  );

  /* ----------------------------
     LOADING
  ----------------------------- */
  if (loading) {
    return (
      <div className="h-full w-full bg-gray-50 animate-pulse" />
    );
  }

  /* ----------------------------
     UI
  ----------------------------- */
  return (
    <div className="bg-white p-4 transition w-full h-full flex flex-col">
      <h3 className="text-sm font-bold text-[#172554] uppercase tracking-wider mb-4 px-2">
        User Summary
      </h3>

      <div className="space-y-4">
        <StatRow
          label="Clients"
          value={stats.clients}
          dot="bg-purple-500"
        />
        <StatRow
          label="Admins"
          value={stats.admins}
          dot="bg-orange-500"
        />
        <StatRow
          label="Delivery Partners"
          value={stats.delivery}
          dot="bg-emerald-500"
        />
      </div>
    </div>
  );
};
  
export default UserStatsRows;
